import { Component, computed, input, model, output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faEdit, faPhone, faEnvelope, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { LoaderComponent } from '../../../core/loader/loader.component';
import { ProfileTab } from './profile-tab.interface';
import { Account } from '../../../api/models/account';

@Component({
  selector: 'app-profile-shell',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    FontAwesomeModule,
    LoaderComponent,
  ],
  templateUrl: './profile-shell.component.html',
})
export class ProfileShellComponent {
  isLoading = input<boolean>(false);
  tabs = input<ProfileTab[]>([]);
  activeTab = model<string>('');
  containerClass = input<string>('');
  account = input<Account | null>(null);
  profileCity = input<string>('');
  /** Explicit display name; takes precedence over the account-derived name when set. */
  displayName = input<string>('');

  editAvatar = output<void>();

  faEdit = faEdit;
  faPhone = faPhone;
  faEnvelope = faEnvelope;
  faMapMarkerAlt = faMapMarkerAlt;

  visibleTabs = computed(() =>
    this.tabs().filter(tab => !tab.visible || tab.visible())
  );

  profileName = computed(() => {
    const acc = this.account();
    if (!acc) return '';
    const parts = [acc.firstName, acc.infix, acc.lastName].filter(Boolean);
    return parts.join(' ');
  });

  /**
   * Name shown in the header. Prefers an explicit `displayName` (e.g. derived from the
   * student profile, which is loaded fresh on the profile page) and falls back to the
   * account-derived name. This avoids the empty header on a newly created profile, where
   * the account name is not yet populated.
   */
  resolvedName = computed(() => this.displayName() || this.profileName());

  avatarUri = computed(() => this.account()?.avatarUri || '');

  selectTab(tab: ProfileTab) {
    this.activeTab.set(tab.id);
    tab.onActivate?.();
  }
}
